import { ChangeLog, ChangeLogView } from "src/components/change-log/ChangeLog";

export function ChangeLogPage() {
  return <ChangeLog view={ChangeLogView.Global} />;
}
